import { uuidv4 } from "@/app/csr-src/utils/uuidUtils";
import {
    PROMOTION_KEY, ProductItemInfo,
    REMOVE_KEY, PRODUCT_ITEM_CORE_KEY, PRODUCT_ITEM_BASIC_KEY, PRODUCT_ITEM_EXTINFO_KEY
} from "@/app/csr-src/apis/cart/cart.interface";
import { DEF_ADDRESS_BODY } from "@/common-components-src/api/address/address.interface";
import { getUserUUIDFromCookie } from "@/utils/userUtils";

export const safeParse = (markInfo: any) => {
    try {
        return JSON.parse(markInfo);
    } catch {
        return null; // 返回 null 表示解析失败
    }
};

// 获取商品列表数据
export const getProductItems = (cartData: any) => {
    if (!cartData || !cartData.data) {
        return {};
    }
    // 商品列表楼层
    const hierarchyRoot = cartData?.hierarchy?.root || []; // 获取下架商品
    const hasStockKey = cartData?.hierarchy?.default_group_uuid_common_has_stock || []; // 获取有货商品
    const noStockKey = cartData?.hierarchy?.default_group_uuid_common_no_stock || []; // 获取无货商品
    const productItemsHasStock: { info: ProductItemInfo }[] = [];
    const productItemsNoStock: { info: ProductItemInfo }[] = [];
    const productItemsReMove: { info: ProductItemInfo }[] = [];
    //下架商品
    function processHierarchyKey(key: string) {
        const item = cartData?.data[key];
        if (
            item &&
            "type" in item &&
            item.type &&
            (item.type.namespace === REMOVE_KEY)
        ) {
            productItemsReMove.push(item as { info: ProductItemInfo });
        }
        const subKeys = (cartData?.hierarchy && cartData?.hierarchy[key]) || [];
        subKeys.forEach(processHierarchyKey);
    }
    hierarchyRoot.forEach(processHierarchyKey);
    // 有货
    function processHasStockKey(key: string) {
        const item = cartData?.data[key];
        if (item) {
            productItemsHasStock.push(item as { info: ProductItemInfo });
        }
        const subKeys = (cartData?.hierarchy && cartData?.hierarchy[key]) || [];
        subKeys.forEach(processHasStockKey);
    }
    hasStockKey.forEach(processHasStockKey);
    // 无货
    function processNoStockKey(key: string) {
        const item = cartData?.data[key];
        if (item) {
            productItemsNoStock.push(item as { info: ProductItemInfo });
        }
        const subKeys = (cartData?.hierarchy && cartData?.hierarchy[key]) || [];
        subKeys.forEach(processNoStockKey);
    }
    noStockKey.forEach(processNoStockKey);
    return {
        productItemsHasStock,
        productItemsNoStock,
        productItemsReMove,
    };
};

// 编辑模式更新选中态
export const updateProductItems = (curItem: any, productItems: any, productItemsNoStock: any, productItemsRemove: any) => {
    const updatedProductItems = productItems?.map((productItem: any) => {
        if (productItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId === curItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId) {
            const isCheck = curItem.info[PRODUCT_ITEM_BASIC_KEY].activeCheck;
            if (productItem?.info?.[PRODUCT_ITEM_BASIC_KEY]) {
                productItem.info[PRODUCT_ITEM_BASIC_KEY].activeCheck = isCheck === 1 ? 0 : 1;
            }
        }
        return productItem;
    });
    const updatedNoStockProductItems = productItemsNoStock?.map((productItem: any) => {
        if (productItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId === curItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId) {
            const isCheck = curItem.info[PRODUCT_ITEM_BASIC_KEY].activeCheck;
            if (productItem?.info?.[PRODUCT_ITEM_BASIC_KEY]) {
                productItem.info[PRODUCT_ITEM_BASIC_KEY].activeCheck = isCheck === 1 ? 0 : 1;
            }
        }
        return productItem;
    });
    const updatedRemoveProductItems = productItemsRemove?.map((productItem: any) => {
        if (productItem?.info?.["C-M#abstractUnusableProductItem&core"]?.skuId === curItem?.info?.["C-M#abstractUnusableProductItem&core"]?.skuId) {
            const isCheck = curItem.info["HJM-M#unusableProductModel&basic"].activeCheck || 0;
            console.log("curItem", curItem, productItemsRemove, isCheck, productItem?.info?.["HJM-M#unusableProductModel&basic"]);
            if (productItem?.info?.["HJM-M#unusableProductModel&basic"]) {
                productItem.info["HJM-M#unusableProductModel&basic"].activeCheck = isCheck === 1 ? 0 : 1;
            }
        }
        return productItem;
    });
    return {
        updatedProductItems,
        updatedNoStockProductItems,
        updatedRemoveProductItems,
    };
};

export const handleDeleteParams = (curDeleteItem: any) => {
    // 删除单选
    console.log("curDeleteItem", curDeleteItem);
    if (!curDeleteItem) {
        return {};
    }
    const uuid = uuidv4();
    let products = {};
    let promotions = {};
    // 已下架商品
    const isUnusableItem = curDeleteItem?.info?.["C-M#abstractUnusableProductItem&basic"];
    if (curDeleteItem?.partList && curDeleteItem?.partList.length > 0) {
        const partItem = curDeleteItem?.partList?.filter(
            (item: any) => item?.info?.[PROMOTION_KEY]?.activeCheck === 1 && item?.info?.[PROMOTION_KEY]?.promoType === "10",
        );
        // 总价促销如果有赠品则需要添加这些入参
        if (partItem && partItem.length > 0) {
            promotions = {
                ...promotions,
                id: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                promotionId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                itemType: "3",
            };
            products = {
                ...products,
                parentId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
            };
        }
    }
    products = {
        ...products,
        skuId: isUnusableItem ? curDeleteItem?.info["C-M#abstractUnusableProductItem&core"]?.skuId : curDeleteItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId,
        num: isUnusableItem ? curDeleteItem?.info["C-M#abstractUnusableProductItem&basic"]?.num : curDeleteItem?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        itemType: isUnusableItem ? curDeleteItem?.info?.["C-M#abstractUnusableProductItem&basic"]?.itemType : curDeleteItem?.info?.["HJM-M#cartProduct&extInfo"]?.itemType,
        id: uuid,
    };
    promotions = {
        ...promotions,
        num: isUnusableItem ? curDeleteItem?.info?.["C-M#abstractUnusableProductItem&basic"]?.num : curDeleteItem?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        childList: [uuid],
    };
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations: {
            products: [products],
            promotions: [promotions],
        },
        userActionId: "removeCart",
        extendParamMap: {
            stock: true,
        },
    };
};

// 删除多选
export const handleSelectDeleteParams = (cartData: any, isSingleDeleteAll = false) => {
    if (!cartData || !cartData.data) {
        return {};
    }
    const { productItemsHasStock, productItemsNoStock, productItemsReMove } = getProductItems(cartData);
    console.log("cartData111", productItemsHasStock, productItemsNoStock, productItemsReMove);
    const operations: {
        products: any[];
        promotions: any[];
    } = {
        products: [],
        promotions: [],
    };
    // 查询选中的有货商品
    if (!isSingleDeleteAll && productItemsHasStock && productItemsHasStock.length > 0) {
        // 遍历选中的商品
        productItemsHasStock
            .filter((item: any) => item?.info["C-M#productItem&basic"]?.activeCheck === 1)
            .forEach((item: any) => {
                const uuid = uuidv4();
                let products = {};
                // 检查促销信息
                if (item?.partList && item?.partList.length > 0) {
                    const partItem = item.partList.filter(
                        (part: any) =>
                            part?.info?.[PROMOTION_KEY]?.activeCheck === 1 &&
                            part?.info?.[PROMOTION_KEY]?.promoType === "10",
                    );
                    // 如果有促销信息,添加相关字段
                    if (partItem && partItem.length > 0) {
                        const promoId = partItem[0]?.info?.[PROMOTION_KEY]?.id;
                        products = {
                            ...products,
                            parentId: uuid,
                        };
                        operations.promotions.push({
                            id: uuid,
                            promotionId: promoId,
                            itemType: "3",
                            num: item?.info["C-M#productItem&basic"]?.num,
                            childList: [uuid],
                        });
                    }
                }
                products = {
                    ...products,
                    skuId: item?.info?.["C-M#productItem&core"]?.skuId,
                    num: item?.info?.["C-M#productItem&basic"]?.num,
                    itemType: item?.info?.["HJM-M#cartProduct&extInfo"]?.itemType,
                    id: uuid,
                };
                operations.products.push(products);
            });
    }
    // 查询选中的无货商品
    if (!isSingleDeleteAll && productItemsNoStock && productItemsNoStock.length > 0) {
        // 遍历选中的商品
        productItemsNoStock
            .filter((item: any) => item?.info["C-M#productItem&basic"]?.activeCheck === 1)
            .forEach((item: any) => {
                const uuid = uuidv4();
                let products = {};
                // 检查促销信息
                if (item?.partList && item?.partList.length > 0) {
                    const partItem = item.partList.filter(
                        (part: any) =>
                            part?.info?.[PROMOTION_KEY]?.activeCheck === 1 &&
                            part?.info?.[PROMOTION_KEY]?.promoType === "10",
                    );
                    // 如果有促销信息,添加相关字段
                    if (partItem && partItem.length > 0) {
                        const promoId = partItem[0]?.info?.[PROMOTION_KEY]?.id;
                        products = {
                            ...products,
                            parentId: uuid,
                        };
                        operations.promotions.push({
                            id: uuid,
                            promotionId: promoId,
                            itemType: "3",
                            num: item?.info["C-M#productItem&basic"]?.num,
                            childList: [uuid],
                        });
                    }
                }
                products = {
                    ...products,
                    skuId: item?.info?.["C-M#productItem&core"]?.skuId,
                    num: item?.info?.["C-M#productItem&basic"]?.num,
                    itemType: item?.info?.["HJM-M#cartProduct&extInfo"]?.itemType,
                    id: uuid,
                };
                operations.products.push(products);
            });
    }
    // 查询选中的下架商品 isSingleDeleteAll 为true 不需要筛选 activeCheck 状态
    if (productItemsReMove && productItemsReMove.length > 0) {
        // 遍历选中的商品
        productItemsReMove
            .filter((item: any) => {
                if(isSingleDeleteAll){
                    return item;
                }
                return item?.info["HJM-M#unusableProductModel&basic"]?.activeCheck === 1;
            })
            .forEach((item: any) => {
                const uuid = uuidv4();
                let products = {};
                // 检查促销信息
                if (item?.partList && item?.partList.length > 0) {
                    const partItem = item.partList.filter(
                        (part: any) =>
                            part?.info?.["HJM-M#unusableProductModel&basic"]?.activeCheck === 1 &&
                            part?.info?.["HJM-M#unusableProductModel&basic"]?.promoType === "10",
                    );
                    // 如果有促销信息,添加相关字段
                    if (partItem && partItem.length > 0) {
                        const promoId = partItem[0]?.info?.[PROMOTION_KEY]?.id;
                        products = {
                            ...products,
                            parentId: uuid,
                        };
                        operations.promotions.push({
                            id: uuid,
                            promotionId: promoId,
                            itemType: "3",
                            num: item?.info["C-M#abstractUnusableProductItem&basic"]?.num,
                            childList: [uuid],
                        });
                    }
                }
                products = {
                    ...products,
                    skuId: item?.info?.["C-M#abstractUnusableProductItem&core"]?.skuId,
                    num: item?.info?.["C-M#abstractUnusableProductItem&basic"]?.num,
                    itemType: item?.info?.["C-M#abstractUnusableProductItem&basic"]?.itemType,
                    id: uuid,
                };
                operations.products.push(products);
            });
    }
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations,
        userActionId: "removeCart",
        extendParamMap: {
            stock: true,
        },
    };
};

// 商品下沉，稍后购买 (此功能315版本去掉了)
export const saveForLater = (curDeleteItem: any) => {
    console.log("saveForLater", curDeleteItem);
    if (!curDeleteItem) {
        return {};
    }
    const uuid = uuidv4();
    let products = {};
    let promotions = {};
    if (curDeleteItem?.partList && curDeleteItem?.partList.length > 0) {
        const partItem = curDeleteItem?.partList?.filter(
            (item: any) => item?.info?.[PROMOTION_KEY]?.activeCheck === 1 && item?.info?.[PROMOTION_KEY]?.promoType === "10",
        );
        // 总价促销如果有赠品则需要添加这些入参
        if (partItem && partItem.length > 0) {
            promotions = {
                ...promotions,
                id: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                promotionId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                itemType: "3",
            };
            products = {
                ...products,
                parentId: uuid,
            };
        }
    }
    products = {
        ...products,
        skuId: curDeleteItem?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId,
        num: curDeleteItem?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        itemType: curDeleteItem?.info?.["HJM-M#cartProduct&extInfo"]?.itemType,
        id: uuid,
    };
    promotions = {
        ...promotions,
        num: curDeleteItem?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        childList: [uuid],
    };
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations: {
            products: [products],
            promotions: [promotions],
            updateTags: ["saveForLater"],
        },
        userActionId: "updateOtherInfos",
        extendParamMap: {
            stock: true,
        },
    };
};

export const updateProductItemParams = (targetSkuId: string, curProItemType: any) => {
    if (!curProItemType) {
        return {};
    }
    const uuid = uuidv4();
    let products = {};
    let promotions = {};
    if (curProItemType?.partList && curProItemType?.partList.length > 0) {
        const partItem = curProItemType?.partList?.filter(
            (item: any) => item?.info?.[PROMOTION_KEY]?.activeCheck === 1 && item?.info?.[PROMOTION_KEY]?.promoType === "10",
        );
        // 总价促销如果有赠品则需要添加这些入参
        if (partItem && partItem.length > 0) {
            promotions = {
                ...promotions,
                id: uuid,
                parentId: uuid,
                promotionId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                itemType: "3",
            };
            products = {
                ...products,
                parentId: uuid,
            };
        }
    }
    products = {
        ...products,
        skuId: curProItemType?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId,
        num: curProItemType?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        itemType: curProItemType?.info?.[PRODUCT_ITEM_EXTINFO_KEY]?.itemType,
        id: uuid,
        targetSkuId: targetSkuId,
    };
    promotions = {
        ...promotions,
        num: curProItemType?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        childList: [uuid],
    };
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations: {
            products: [products],
            promotions: [promotions],
        },
        userActionId: "switchCart",
        extendParamMap: {
            stock: true,
        },
    };
};

export const handleChangeNumParams = (item: any, num: number) => {
    if (!item) {
        return {};
    }
    const uuid = uuidv4();
    let products = {};
    let promotions = {};
    if (item?.partList && item?.partList.length > 0) {
        const partItem = item?.partList?.filter((item: any) => item?.info?.[PROMOTION_KEY]?.activeCheck === 1 && item?.info?.[PROMOTION_KEY]?.promoType === "10");
        // 总价促销如果有赠品则需要添加这些入参
        if (partItem && partItem.length > 0) {
            promotions = {
                ...promotions,
                id: uuid,
                parentId: uuid,
                promotionId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                itemType: "3",
            };
            products = {
                ...products,
                parentId: uuid,
            };
        }
    }
    products = {
        ...products,
        skuId: item?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId,
        num: String(num),
        itemType: item?.info?.[PRODUCT_ITEM_EXTINFO_KEY]?.itemType,
        id: uuid,
    };
    promotions = {
        ...promotions,
        num: String(num),
        childList: [uuid],
    };
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations: {
            products: [products],
            promotions: [promotions],
        },
        userActionId: "changeNum",
        extendParamMap: {
            stock: true,
        },
    };
};

export const handleItemCheckParams = (item: any) => {
    if (!item) {
        return {};
    }
    const uuid = uuidv4();
    let products = {};
    let promotions = {};
    if (item?.partList && item?.partList.length > 0) {
        const partItem = item?.partList?.filter((item: any) => item?.info?.[PROMOTION_KEY]?.activeCheck === 1 && item?.info?.[PROMOTION_KEY]?.promoType === "10");
        // 总价促销如果有赠品则需要添加这些入参
        if (partItem && partItem.length > 0) {
            promotions = {
                ...promotions,
                id: uuid,
                parentId: uuid,
                promotionId: partItem?.[0]?.info?.[PROMOTION_KEY]?.id,
                itemType: "3",
            };
            products = {
                ...products,
                parentId: uuid,
            };
        }
    }
    products = {
        ...products,
        skuId: item?.info?.[PRODUCT_ITEM_CORE_KEY]?.skuId,
        num: item?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        itemType: item?.info?.[PRODUCT_ITEM_EXTINFO_KEY]?.itemType,
        id: uuid,
    };
    promotions = {
        ...promotions,
        num: item?.info?.[PRODUCT_ITEM_BASIC_KEY]?.num,
        childList: [uuid],
    };
    return {
        verticalTag: "cn_ybxt_b2c",
        area: DEF_ADDRESS_BODY.area,
        cartuuid: getUserUUIDFromCookie(),
        operations: {
            products: [products],
            promotions: [promotions],
        },
        userActionId: item?.info?.[PRODUCT_ITEM_BASIC_KEY]?.activeCheck === 1 ? "unselect" : "select",
        extendParamMap: {
            stock: true,
        },
    };
};